import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import partialRight from 'lodash/partialRight';
import { focusDone } from '../redux/actionCreators';
import { getIsFocusRequested } from '../redux/selectors';
import { useEditorDraftState } from './useEditorDraftState';
/**
 * A Comment specific callback that we pass to `DaEditor's` `onEditorReady` prop.
 */
export function useCommentDaEditorReadyHandler(editorId, autoFocus) {
    var dispatch = useDispatch();
    var isFocusRequested = useSelector(partialRight(getIsFocusRequested, editorId, autoFocus));
    var hasDraft = useEditorDraftState(editorId);
    return useCallback(function (toolbars, api) {
        if (isFocusRequested) {
            dispatch(focusDone(editorId));
        }
        // We don't want to auto-focus drafts because they are triggered on pageload, this
        // avoids users getting lost when keyboard is bound to something potentially off-screen
        if (hasDraft && !isFocusRequested) {
            return;
        }
        api.focusEditor(); // auto focus the editor because we always use lazyload and that will steal the click
    }, [isFocusRequested, dispatch, editorId, hasDraft]);
}
//# sourceMappingURL=useCommentDaEditorReadyHandler.js.map